<template>
  <v-app>
    <v-navigation-drawer app
      color="primaryLight"
      class="white--text"
      :mini-variant.sync="mini"
      permanent>
      <v-list-item class="px-2 white">
        <v-list-item-avatar>
          <v-img :src="require('@/assets/logo.png')"></v-img>
        </v-list-item-avatar>
        <v-list-item-title class="primaryLight--text"><h2>Dr. Admin</h2></v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="openSection(item.section)">
          <v-list-item-icon>
            <v-icon class="white--text">{{item.icon}}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title><h3 class="white--text">{{item.name}}</h3></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider color="white"></v-divider>

        <v-list-item link @click="goToHome()">
          <v-list-item-icon>
            <v-icon class="white--text">mdi-arrow-left</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title><h3 class="white--text">Return home</h3></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="white" link @click="openLogout()">
          <v-list-item-icon>
            <v-icon class="red--text">mdi-import</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title><h3 class="red--text">Logout</h3></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="std-background">
      <v-main class="pl-0">
        <v-container fluid>
          <BookingsList v-if="showBookingsList"/>
          <ClientsList v-if="showClientsList"/>
        </v-container>
      </v-main>
    </div>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="primaryLight--text pb-10">
          Are you sure you want to logout?
        </v-card-title>
        <v-card-actions class="pb-5 pr-8 pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primaryLight" text @click="dialog = false">Cancel</v-btn>
          <v-btn depressed color="primaryLight" class="white--text" @click="logout()">
            Confirm logout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import ClientsList from './ClientsList'
  import BookingsList from './BookingsList'

  export default {
    name: 'Dashboard',
    components: {
      BookingsList,
      ClientsList
    },
    data() {
      return {
        dialog: false,
        showAnalytics: false,
        showBookingsList: false,
        showClientsList: false,
        items: [
          { name: 'Analytics', icon: 'mdi-finance', section: 'analytics' },
          { name: 'Bookings', icon: 'mdi-book-clock-outline', section: 'bookingsList' },
          { name: 'Clients', icon: 'mdi-account-group-outline', section: 'clientsList' }
        ]
      }
    },
    computed: {
      mini: {
        get() {
          return this.$vuetify.breakpoint.smAndDown
        },
        set() {}
      }
    },
    methods: {
      openSection(section) {
        this.showClientsList = false
        this.showBookingsList = false
        this.showAnalytics = false
        switch (section) {
          case 'clientsList':
            this.showClientsList = true
            break
          case 'bookingsList':
            this.showBookingsList = true
            break
          case 'analytics':
            this.showAnalytics = true
            break
        }
      },
      goToHome() {
        window.location = 'https://drasmahhealthhub.com'
      },
      openLogout() {
        this.dialog = true
      },
      logout() {
        this.$store.dispatch('logout').then(() => {
          this.dialog = false
          window.location = 'https://drasmahhealthhub.com'
        })
      }
    }
  }
</script>
